var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"prizes",attrs:{"back-button-to":"/menu","header":_vm.$t('prizes.header')}},[_c('VBlock',{attrs:{"max-width":"500px"}},[_c('img',{attrs:{"src":require("@/assets/prizes.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }